var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6263 1.76153C17.591 0.625613 16.1704 0 14.6259 0C13.4714 0 12.4141 0.369224 11.4833 1.09733C11.0137 1.46486 10.5881 1.9145 10.2129 2.43932C9.83783 1.91466 9.41211 1.46486 8.94229 1.09733C8.01166 0.369224 6.95438 0 5.7999 0C4.2554 0 2.83466 0.625613 1.79935 1.76153C0.776398 2.88418 0.212891 4.41788 0.212891 6.08032C0.212891 7.79138 0.843231 9.35765 2.19653 11.0096C3.40717 12.4873 5.14713 13.9873 7.16205 15.7243C7.85007 16.3175 8.62994 16.9899 9.43973 17.7061C9.65366 17.8957 9.92816 18 10.2129 18C10.4975 18 10.7721 17.8957 10.9857 17.7064C11.7955 16.99 12.5759 16.3173 13.2642 15.7238C15.2788 13.9872 17.0188 12.4873 18.2294 11.0094C19.5827 9.35765 20.2129 7.79138 20.2129 6.08016C20.2129 4.41788 19.6494 2.88418 18.6263 1.76153Z",
    fill: "#DE010E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilled);
export default __webpack_public_path__ + "static/media/like-filled.3616243b4081e2e35d983660ab88e8c9.svg";
export { ForwardRef as ReactComponent };